import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as instructorActions from '../../_actions/department.actions'
import { Select } from 'antd'

class Departments extends PureComponent {
    componentDidMount() {
        // if (this.props.departments.length === 0) {
        //     this.props.actions.fetchDepartmentList()
        // }
    }

    render() {
        if (this.props.selectedDepartments) {
            return (
                <Select
                    mode="multiple"
                    allowClear
                    style={{
                        width: '100%',
                    }}
                    placeholder="Select departments"
                    defaultValue={[]}
                    options={this.props.departments}
                    onChange={this.props.handleChange}
                    value={this.props.selectedDepartments}
                    maxTagCount="responsive"
                    filterOption={(input, option) =>
                        (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.toLowerCase())
                    }
                />
            )
        } else {
            return (
                <Select
                    mode="multiple"
                    allowClear
                    style={{
                        width: '100%',
                    }}
                    placeholder="Select departments"
                    defaultValue={[]}
                    options={this.props.departments}
                    onChange={this.props.handleChange}
                    maxTagCount="responsive"
                    filterOption={(input, option) =>
                        (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.toLowerCase())
                    }
                />
            )
        }
    }
}

function mapStateToProps(state) {
    return {
        departments: state.DepartmentReducer.departmentList,
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(instructorActions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Departments)
